// errorReporter — праща frontend грешките към вградения инбокс (/api/errors/report).
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const sent = new Set();
let budget = 15;

async function send(payload) {
  const key = `${payload.message}|${payload.component || ""}`.slice(0, 180);
  if (sent.has(key) || budget <= 0) return;
  sent.add(key);
  budget -= 1;
  try {
    await axios.post(`${API}/errors/report`, {
      source: "frontend",
      url: window.location.href,
      user_agent: navigator.userAgent,
      ...payload,
    }, { timeout: 8000 });
  } catch { /* никога не хвърляме от репортера */ }
}

export function reportError(message, extra = {}) {
  send({ message: String(message).slice(0, 2000), level: "error", ...extra });
}

export function installErrorReporter() {
  window.addEventListener("error", (e) => {
    if (!e?.message) return;
    send({
      message: e.message,
      stack: e.error?.stack,
      component: e.filename ? `${e.filename}:${e.lineno}` : undefined,
      level: "error",
    });
  });

  window.addEventListener("unhandledrejection", (e) => {
    const r = e?.reason;
    send({
      message: (r?.message || String(r || "unhandled rejection")).slice(0, 2000),
      stack: r?.stack,
      level: "error",
      component: "unhandledrejection",
    });
  });

  axios.interceptors.response.use(
    (r) => r,
    (error) => {
      const st = error?.response?.status;
      if (st >= 500) {
        send({
          message: `API ${st} ${error.config?.method?.toUpperCase() || ""} ${error.config?.url || ""}`,
          level: "error",
          component: "axios",
          extra: { status: st, data: String(error.response?.data || "").slice(0, 500) },
        });
      }
      return Promise.reject(error);
    },
  );
}
